import clsx from 'clsx';
import styles from './WidgetForm.module.scss';

interface WidgetFormProps {
  children: React.ReactNode;
  variant?: 'default' | 'responsive';
}

export const WidgetForm = ({ children, variant = 'default' }: WidgetFormProps) => (
  <form className={clsx(styles.form, variant === 'responsive' && styles.formResponsive)}>
    {children}
  </form>
);
